<template>
   <div class="banner">
      <div class="myMurdochHolder">
         <header class="logo-header">
            <div class="container">
               <a href="http://www.murdoch.edu.au"><img src="//static.murdoch.edu.au/precedent/images/murdoch-logo-hoz-white.svg" class="logo" alt="Murdoch University logo"></a>
               <ul class="header-global-links">
                  <!-- Top/global Navigation for Internal Audiences -->
                  <li><a href="http://goto.murdoch.edu.au/Library" class="external-link" target="_blank">Library</a></li>
                  <li><a href="http://goto.murdoch.edu.au/StudentInfo" class="external-link" target="_blank">Current Students</a></li>
                  <li><a href="http://goto.murdoch.edu.au/StaffInfo" class="external-link" target="_blank">Staff</a></li>
               </ul>
            </div>
         </header>
      </div>
      <div class="container">
         <div class="header">{{ title }}</div>
         <div class="tag_line">{{ subTitle }}</div>
         <div class="tabs">
            <Tabs v-if="this.currentStep"
               :steps="this.steps"
               :currentStep="this.currentStep.id"
               @goTo="changeStep"
            ></Tabs>
         </div>
      </div>
   </div>
</template>

<script>
   import { mapGetters, mapActions } from 'vuex'
   export default {
      computed: {
         ...mapGetters({
            title: 'getTitle',
            subTitle: 'getSubTitle',
            steps: 'getSteps',
            currentStep: 'getCurrentStep',
         })
      },
      methods: {
         ...mapActions([
            'setCurrent'
         ]),
         changeStep(step){
            if(step.id != this.currentStep.id){
               this.setCurrent(step.id)
               this.$router.push({name: step.name})
            }
         },
      }
   }
</script>

<style>
</style>
